"use client"

import {values} from "mobx";
import VerticalBlock from "../blocks/TerracedGridTheme/Terrace";

import classNames from "classnames";
import styles from "./styles/StaticGrid.module.scss";
import {useStores} from "../../stores/useStores";
import {observer} from "mobx-react";

const pageBodyClassName = classNames({
    [styles.pageBody]: true,
});

 const TerracedGrid = observer((props: {
     blockPromises: {[key: string]: Promise<any>},
 }) => {
    const {gridStore, userStore, modalStore} = useStores();
    const content = values(gridStore.blocks);

     const handleClick = () => {
         modalStore.addModal({type: "terraceManagementModal"})
     }

    return <main className={pageBodyClassName} role="main" id={'main'}>
        {content.length === 0 && userStore.isEditor ? <div className={styles.noContent}>
            You haven't added any terraces yet!
            <div>
                <button onClick={handleClick}>Add One Now</button>
            </div>
        </div> : content.filter(blockObj => blockObj.type !== "hero")
            .map((blockObj, index) => {
                return <VerticalBlock
                    key={blockObj.id}
                    blockObj={blockObj}
                    aboveTheFold={index === 0}
                    initialBlockPromise={props.blockPromises[blockObj.id] ?? null}
                />
            })}
    </main>
})

export default TerracedGrid;